<app-mmp-ai-summary
  [progressTagMsg]="progressTagMsg"
  progressTagClass="completed"
  [confidenceScore]="aiSummaryConfidenceScore"
  [currentTab]="currentStage"
  [courseMatched]="aiSummaryCourseMatched"
  [courseNotMatched]="aiSummaryCourseNotMatched"
  [flaggedCount]="aiSummaryFlaggedCount"
  [progressTimeText]="progressTimeText"
  [progressTime]="progressTime"
></app-mmp-ai-summary>
<div class="equivalency-container">
  <div class="equivalency-header header-section horizontal-line">
    <div class="equivalency-title title-section">Equivalency Result</div>
    <div class="equivalency-flag-toggle toggle-section horizontal-line">
      <app-mmp-flag-component></app-mmp-flag-component>
      Flagged Items Only
      <label class="switch" for="highlight_toggle">
        <input
          type="checkbox"
          class="higlight-toggle"
          [(ngModel)]="isHighlightToggleChecked"
          (ngModelChange)="onHighlightToggleChange()"
          id="highlight_toggle"
          aria-label="Toggle to show flagged items only"
          [disabled]="editingCourse"
        />
        <span class="slider round" aria-hidden="true"></span>
      </label>
    </div>
  </div>
  <div class="equivalency-body">
    @if (isHighlightToggleChecked && visibleTranscripts.length === 0) {
      <div class="no-flagged-item">No flagged items found.</div>
    } @else {
      <mat-tab-group
        class="transcript-group"
        [(selectedIndex)]="selectedTranscriptIndex"
        (click)="onTabClick($event)"
        (keydown)="onTabClick($event)"
        (selectedIndexChange)="onTabChange($event)"
      >
        @for (
          transcript of visibleTranscripts;
          track transcript;
          let i = $index
        ) {
          <mat-tab
            [label]="transcript.name"
            [disabled]="transcriptAlert || editingCourse"
          >
            <ng-template mat-tab-label>
              <span class="transcript-tab-label-wrap">
                @if (hasNoMatchInTab(i)) {
                  <app-mmp-flag-component></app-mmp-flag-component>
                }
                <span
                  class="transcript-tab-label-text"
                  [title]="transcript.name"
                >
                  {{ transcript.name }}
                </span>
              </span>
            </ng-template>
            <ng-template matTabContent class="table-container">
              @if (transcriptAlert) {
                <div class="transcript-alert">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_transcript_alert)">
                      <path
                        d="M2.25 9C2.25 9.88642 2.42459 10.7642 2.76381 11.5831C3.10303 12.4021 3.60023 13.1462 4.22703 13.773C4.85382 14.3998 5.59794 14.897 6.41689 15.2362C7.23583 15.5754 8.11358 15.75 9 15.75C9.88642 15.75 10.7642 15.5754 11.5831 15.2362C12.4021 14.897 13.1462 14.3998 13.773 13.773C14.3998 13.1462 14.897 12.4021 15.2362 11.5831C15.5754 10.7642 15.75 9.88642 15.75 9C15.75 8.11358 15.5754 7.23583 15.2362 6.41689C14.897 5.59794 14.3998 4.85382 13.773 4.22703C13.1462 3.60023 12.4021 3.10303 11.5831 2.76381C10.7642 2.42459 9.88642 2.25 9 2.25C8.11358 2.25 7.23583 2.42459 6.41689 2.76381C5.59794 3.10303 4.85382 3.60023 4.22703 4.22703C3.60023 4.85382 3.10303 5.59794 2.76381 6.41689C2.42459 7.23583 2.25 8.11358 2.25 9Z"
                        stroke="#FA0000"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M9 6.75V9.75"
                        stroke="#FA0000"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M9 12V12.0075"
                        stroke="#FA0000"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_transcript_alert">
                        <rect width="18" height="18" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  Please save or cancel your changes before moving to the next
                  tab.
                </div>
              }
              <svg width="0" height="0" style="position: absolute;">
                <defs>
                  <g id="search-icon-paths">
                    <path
                      d="M2 6.66667C2 7.2795 2.12071 7.88634 2.35523 8.45252C2.58975 9.01871 2.93349 9.53316 3.36683 9.9665C3.80018 10.3998 4.31462 10.7436 4.88081 10.9781C5.447 11.2126 6.05383 11.3333 6.66667 11.3333C7.2795 11.3333 7.88634 11.2126 8.45252 10.9781C9.01871 10.7436 9.53316 10.3998 9.9665 9.9665C10.3998 9.53316 10.7436 9.01871 10.9781 8.45252C11.2126 7.88634 11.3333 7.2795 11.3333 6.66667C11.3333 6.05383 11.2126 5.447 10.9781 4.88081C10.7436 4.31462 10.3998 3.80018 9.9665 3.36683C9.53316 2.93349 9.01871 2.58975 8.45252 2.35523C7.88634 2.12071 7.2795 2 6.66667 2C6.05383 2 5.447 2.12071 4.88081 2.35523C4.31462 2.58975 3.80018 2.93349 3.36683 3.36683C2.93349 3.80018 2.58975 4.31462 2.35523 4.88081C2.12071 5.447 2 6.05383 2 6.66667Z"
                      stroke="#030213"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14 14L10 10"
                      stroke="#030213"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </defs>
              </svg>
              <table
                mat-table
                class="equivalency-table"
                [dataSource]="transcript.dataSource"
                matSort
              >
                <!-- ================= PREVIOUS COURSE ================= -->
                <ng-container matColumnDef="previousCourse">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Previous Course
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let course"
                    class="previous-course"
                    [ngClass]="{ 'no-match-row': !course.matched_course_title }"
                  >
                    <div class="course-name" [title]="course.course_name">
                      {{ course.course_name }}
                    </div>
                    <small>
                      {{ course.semester }} <b>|</b> {{ course.course_code }}
                    </small>
                  </td>
                </ng-container>
                <!-- ================= MATCHED COURSE ================= -->
                <ng-container matColumnDef="matchedCourse">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Matched Course
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let course"
                    class="matched-course"
                    [ngClass]="{ 'no-match-row': !course.matched_course_title }"
                  >
                    @if (course.matched_course_title && !course.isEditing) {
                      <div>
                        <div
                          class="course-name"
                          [title]="course.matched_course_title"
                        >
                          {{ course.matched_course_title }}
                        </div>
                        <small>{{ course.matched_course_code }}</small>
                      </div>
                    } @else {
                      @if (!course.matched_courses?.length) {
                        <div>
                          <div class="no-match horizontal-line">
                            @if (!course.isEditing) {
                              <span class="warning-icon"> No Match Found </span>
                              <app-mmp-flag-component></app-mmp-flag-component>
                            } @else {
                              <div class="match-selection">
                                <mat-form-field
                                  appearance="outline"
                                  class="match-select"
                                  [ngClass]="{
                                    'field-invalid':
                                      course.mandatoryMatchedCourseMissing,
                                  }"
                                >
                                  <mat-select
                                    #noMatchSelect
                                    placeholder="No Match Found"
                                    [(value)]="course.selectedOption"
                                    panelClass="custom-select-panel"
                                    (selectionChange)="
                                      onCourseSelected($event, course)
                                    "
                                  >
                                    <mat-option class="search-option">
                                      <app-course-search-option
                                        [course]="course"
                                        [selectRef]="noMatchSelect"
                                        [searchInputId]="'search-course-no-match-' + i"
                                        [filteredOptions$]="filteredOptions$"
                                        [statusMessage]="statusMessage"
                                        [courseSearchText]="courseSearchText"
                                        [addingCourse]="addingCourse"
                                        [MESSAGES]="MESSAGES"
                                        (searchInputChange)="courseSearchText = $event"
                                        (searchInput)="onSearchInput()"
                                        (searchEnter)="onSearchEnterSelectActive($event)"
                                        (addCourse)="openAddCourseDialog($event.course, $event.selectRef, $event.event)"
                                      ></app-course-search-option>
                                    </mat-option>
                                    @for (
                                      universityCourse of filteredOptions$
                                        | async;
                                      track universityCourse
                                    ) {
                                      <mat-option [value]="universityCourse">
                                        <app-course-option-row
                                          [courseOption]="universityCourse"
                                          [highlightedCourseOption]="highlightedCourseOption"
                                        ></app-course-option-row>
                                      </mat-option>
                                    }
                                  </mat-select>
                                </mat-form-field>
                              </div>
                            }
                          </div>
                        </div>
                      } @else {
                        <div class="multi-match horizontal-line">
                          @if (!course.isEditing) {
                            <span class="warning-icon"
                              >Multiple matches found</span
                            >
                          } @else {
                            <div class="match-selection">
                              @if (!course.showAllCourses) {
                                <mat-form-field
                                  appearance="outline"
                                  class="match-select"
                                  [ngClass]="{
                                    'field-invalid':
                                      course.mandatoryMatchedCourseMissing,
                                  }"
                                >
                                  <mat-select
                                    placeholder="Multiple Matches Found"
                                    [value]="
                                      course.matched_course_code +
                                      ' - ' +
                                      course.matched_course_title
                                    "
                                    panelClass="custom-select-panel"
                                    (selectionChange)="
                                      onCourseSelected($event, course)
                                    "
                                  >
                                    @for (
                                      matchedCourse of course.matched_courses;
                                      track matchedCourse
                                    ) {
                                      <mat-option
                                        [value]="
                                          matchedCourse.code +
                                          ' - ' +
                                          matchedCourse.title
                                        "
                                      >
                                        {{
                                          matchedCourse.code +
                                            " - " +
                                            matchedCourse.title
                                        }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </mat-form-field>
                              }
                              @if (course.showAllCourses) {
                                <mat-form-field
                                  appearance="outline"
                                  class="match-select"
                                  [ngClass]="{
                                    'field-invalid':
                                      course.mandatoryMatchedCourseMissing,
                                  }"
                                >
                                  <mat-select
                                    #allCourseSelect
                                    placeholder="Multiple Match Found"
                                    [(value)]="course.selectedOption"
                                    panelClass="custom-select-panel"
                                    (selectionChange)="
                                      onCourseSelected($event, course)
                                    "
                                  >
                                    <mat-option class="search-option">
                                      <app-course-search-option
                                        [course]="course"
                                        [selectRef]="allCourseSelect"
                                        [searchInputId]="'search-course-multiple-match-' + i"
                                        [filteredOptions$]="filteredOptions$"
                                        [statusMessage]="statusMessage"
                                        [courseSearchText]="courseSearchText"
                                        [addingCourse]="addingCourse"
                                        [MESSAGES]="MESSAGES"
                                        (searchInputChange)="courseSearchText = $event"
                                        (searchInput)="onSearchInput()"
                                        (searchEnter)="onSearchEnterSelectActive($event)"
                                        (addCourse)="openAddCourseDialog($event.course, $event.selectRef, $event.event)"
                                      ></app-course-search-option>
                                    </mat-option>
                                    @for (
                                      universityCourse of filteredOptions$
                                        | async;
                                      track universityCourse
                                    ) {
                                      <mat-option [value]="universityCourse">
                                        <app-course-option-row
                                          [courseOption]="universityCourse"
                                          [highlightedCourseOption]="
                                            highlightedCourseOption
                                          "
                                        ></app-course-option-row>
                                      </mat-option>
                                    }
                                  </mat-select>
                                </mat-form-field>
                              }
                              <a
                                class="toggle-link"
                                (click)="
                                  course.showAllCourses = !course.showAllCourses
                                "
                              >
                                @if (!course.showAllCourses) {
                                  <small>View All Courses</small>
                                }
                                @if (course.showAllCourses) {
                                  <small>Back to Matches</small>
                                }
                              </a>
                            </div>
                          }
                          @if (!course.isEditing) {
                            <app-mmp-flag-component></app-mmp-flag-component>
                          }
                        </div>
                      }
                    }
                  </td>
                </ng-container>
                <!-- ================= GRADE ================= -->
                <ng-container matColumnDef="grade">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Grade
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let course"
                    [ngClass]="{ 'no-match-row': !course.matched_course_title }"
                  >
                    {{ course.grade }}
                  </td>
                </ng-container>
                <!-- ================= QUARTER CREDITS ================= -->
                <ng-container matColumnDef="quarterCredits">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Qua. Credits
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let course"
                    [ngClass]="{ 'no-match-row': !course.matched_course_title }"
                  >
                    @if (course.isEditing) {
                      <div>
                        <input
                          matInput
                          [id]="'quarter-credits-' + i + '-' + j"
                          type="number"
                          step="0.5"
                          max="10.00"
                          min="0.00"
                          aria-label="Quarter credits"
                          [(ngModel)]="course.quarter_credits"
                          (ngModelChange)="
                            course.mandatoryQuarterCreditsMissing = false
                          "
                          class="editable-input"
                          [ngClass]="{
                            'field-invalid':
                              course.mandatoryQuarterCreditsMissing,
                          }"
                        />
                      </div>
                    } @else {
                      {{ course.quarter_credits }}
                    }
                  </td>
                </ng-container>
                <!-- ================= ACTIONS ================= -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>Actions</th>
                  <td
                    mat-cell
                    *matCellDef="let course"
                    class="actions"
                    [ngClass]="{ 'no-match-row': !course.matched_course_title }"
                  >
                    <!-- SVG kept exactly as is -->
                    @if (!course.isEditing) {
                      <svg
                        class="edit-icon"
                        [class.pointer-none]="
                          (reportFailed$ | async) ||
                          (reportGenerating$ | async) ||
                          (editingCourse && editingCourse !== course)
                        "
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        (click)="onEditClick(course)"
                        (keydown.enter)="onEditClick(course)"
                      >
                        <g clip-path="url(#clip0_edit)">
                          <path
                            d="M6 18.0002H9L16.875 10.1252C17.072 9.92824 17.2282 9.69439 17.3348 9.43702C17.4415 9.17965 17.4963 8.9038 17.4963 8.62523C17.4963 8.34665 17.4415 8.0708 17.3348 7.81343C17.2282 7.55606 17.072 7.32221 16.875 7.12523C16.678 6.92824 16.4442 6.77199 16.1868 6.66538C15.9294 6.55878 15.6536 6.50391 15.375 6.50391C15.0964 6.50391 14.8206 6.55878 14.5632 6.66538C14.3058 6.77199 14.072 6.92824 13.875 7.12523L6 15.0002V18.0002Z"
                            stroke="#5F626B"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M13.125 7.875L16.125 10.875"
                            stroke="#5F626B"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_edit">
                            <rect
                              width="18"
                              height="18"
                              fill="white"
                              transform="translate(3 3)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    }
                    @if (course.isEditing) {
                      <div class="edit-actions">
                        <svg
                          class="cancel-icon"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          (click)="onCancelClick(course)"
                          (keydown.enter)="onCancelClick(course)"
                        >
                          <path
                            d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
                            fill="none"
                          />
                          <g clip-path="url(#clip0_course_cancel)">
                            <path
                              d="M16.5 7.5L7.5 16.5"
                              stroke="#FA0000"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7.5 7.5L16.5 16.5"
                              stroke="#FA0000"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_course_cancel">
                              <rect
                                width="18"
                                height="18"
                                fill="white"
                                transform="translate(3 3)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        <svg
                          class="save-icon"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          (click)="onSaveClick(course)"
                          (keydown)="onSaveClick(course)"
                        >
                          <path
                            d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
                            fill="none"
                          />
                          <g clip-path="url(#clip0_course_save)">
                            <path
                              d="M6.75 12L10.5 15.75L18 8.25"
                              stroke="#088E6D"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_course_save">
                              <rect
                                width="18"
                                height="18"
                                fill="white"
                                transform="translate(3 3)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    }
                  </td>
                </ng-container>
                <!-- ================= ROW DEFINITIONS ================= -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td
                    class="mat-cell empty-result"
                    [attr.colspan]="displayedColumns.length"
                  >
                    No Courses Found
                  </td>
                </tr>
              </table>
            </ng-template>
          </mat-tab>
        }
      </mat-tab-group>
    }
  </div>
  <div class="equivalency-feedback">
    <app-mmp-feedback
      [feedBackStage]="currentStage"
      [finalFeedback]="finalFeedback"
      (closeFinalFeedback)="closeFinalFeedback()"
    ></app-mmp-feedback>
  </div>
  <div
    class="equivalency-notification"
    *ngIf="(reportGenerating$ | async) || (reportFailed$ | async) || (reportCompleted$ | async)"
  >
    <output
      class="alert-text"
      [ngClass]="{
        'report-generating': reportGenerating$ | async,
        'report-failed': reportFailed$ | async,
        'report-completed': (reportCompleted$ | async) && !(reportGenerating$ | async),
      }"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_5124_17806)">
          <path
            d="M2.25 9C2.25 9.88642 2.42459 10.7642 2.76381 11.5831C3.10303 12.4021 3.60023 13.1462 4.22703 13.773C4.85382 14.3998 5.59794 14.897 6.41689 15.2362C7.23583 15.5754 8.11358 15.75 9 15.75C9.88642 15.75 10.7642 15.5754 11.5831 15.2362C12.4021 14.897 13.1462 14.3998 13.773 13.773C14.3998 13.1462 14.897 12.4021 15.2362 11.5831C15.5754 10.7642 15.75 9.88642 15.75 9C15.75 7.20979 15.0388 5.4929 13.773 4.22703C12.5071 2.96116 10.7902 2.25 9 2.25C7.20979 2.25 5.4929 2.96116 4.22703 4.22703C2.96116 5.4929 2.25 7.20979 2.25 9Z"
            [attr.stroke]="
              (reportFailed$ | async)
                ? '#FA0000'
                : (reportGenerating$ | async)
                  ? '#0073B5'
                  : (reportCompleted$ | async)
                    ? '#088E6D'
                    : '#0073B5'
            "
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9 6V9"
            [attr.stroke]="
              (reportFailed$ | async)
                ? '#FA0000'
                : (reportGenerating$ | async)
                  ? '#0073B5'
                  : (reportCompleted$ | async)
                    ? '#088E6D'
                    : '#0073B5'
            "
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9 12H9.00857"
            [attr.stroke]="
              (reportFailed$ | async)
                ? '#FA0000'
                : (reportGenerating$ | async)
                  ? '#0073B5'
                  : (reportCompleted$ | async)
                    ? '#088E6D'
                    : '#0073B5'
            "
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_5124_17806">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
      @if (reportGenerating$ | async) {
        Compiling equivalency results into your report.
      }
      @if (reportFailed$ | async) {
        Something went wrong while generating this report.
      }
      @if ((reportCompleted$ | async) && !(reportGenerating$ | async)) {
        Pre-Evaluation report downloaded successfully.
      }
    </output>
  </div>
  <div class="equivalency-footer">
    <button
      class="mmp-btn-secondary"
      (click)="goToEvaluationTab()"
      [disabled]="editingCourse"
    >
      Back
    </button>
    <button
      class="mmp-btn-primary"
      [ngClass]="{
        'report-failed-btn': reportFailed$ | async,
      }"
      (click)="onGeneratePreEvaluationReport()"
      [disabled]="
        !isAnyRowMatched() ||
        (reportGenerating$ | async) ||
        editingCourse ||
        isTableDataEmpty() ||
        !isAiSummaryCompleted()
      "
      [class.disabled]="
        !isAiSummaryCompleted() ||
        !isAnyRowMatched() ||
        (reportGenerating$ | async) ||
        editingCourse ||
        isTableDataEmpty() ||
        !isAiSummaryCompleted()
      "
      [matTooltip]="getProceedButtonTooltip()"
    >
      @if (reportGenerating$ | async) {
        <span class="report-loading-btn">
          <span class="report-spinner" aria-hidden="true"></span>
          Generating Report...
        </span>
      } @else if (reportFailed$ | async) {
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_4975_13758)">
            <path
              d="M14.9491 9.78075C14.8074 10.8607 14.3745 11.8818 13.6967 12.7344C13.0189 13.587 12.1218 14.239 11.1015 14.6205C10.0813 15.002 8.9765 15.0986 7.90556 14.8999C6.83462 14.7013 5.83796 14.2148 5.02248 13.4927C4.20699 12.7707 3.60345 11.8402 3.27657 10.8012C2.94969 9.76223 2.9118 8.65384 3.16698 7.59494C3.42216 6.53604 3.96077 5.56658 4.72504 4.79052C5.48932 4.01446 6.45044 3.46109 7.50531 3.18975C10.4296 2.43975 13.4566 3.945 14.5741 6.75"
              stroke="#FA0000"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M15 3V6.75H11.25"
              stroke="#FA0000"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_4975_13758">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>

        Retry Generating Report
      } @else {
        Save and Generate Pre-Evaluation Report
      }
    </button>
    <button
      class="mmp-btn-primary"
      (click)="onMarkComplete()"
      [disabled]="!isAnyRowMatched() || editingCourse || !(reportCompleted$ | async)"
    >
      Mark as Completed
    </button>
  </div>
</div>
